module.exports = __webpack_public_path__ + "img/base_activites_cyclo.6ce6cada.svg";